import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const RacismImages = ({ id }) => {
    const data = useStaticQuery(graphql`
        query {
            motif_1: file(relativePath: { eq: "racism/motif/motif_1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_2: file(relativePath: { eq: "racism/motif/motif_2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_3: file(relativePath: { eq: "racism/motif/motif_3.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_4: file(relativePath: { eq: "racism/motif/motif_4.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_5: file(relativePath: { eq: "racism/motif/motif_5.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_6: file(relativePath: { eq: "racism/motif/motif_6.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_7: file(relativePath: { eq: "racism/motif/motif_7.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_8: file(relativePath: { eq: "racism/motif/motif_8.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_9: file(relativePath: { eq: "racism/motif/motif_9.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_10: file(relativePath: { eq: "racism/motif/motif_10.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_11: file(relativePath: { eq: "racism/motif/motif_11.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <Img style={{ width: "100%" }} fluid={data[id].childImageSharp.fluid} />
    )
}

export default RacismImages
